import axios from 'axios'
import './common'

export default {
    getList: (type, params) => axios.get(`/params/${type}`, { params: params }),
    get: (type, id) => axios.get(`/params/${type}/${id}`),
    create: (type, data) => axios.post(`/params/${type}`, data),
    update: (type, id, data) => axios.put(`/params/${type}/${id}`, data),
    updateAsForm(type, id, data) {
        data.append("_METHOD", "PUT");
        return axios.post(`/params/${type}/${id}`, data);
    },
    delete: (type, id) => axios.delete(`/params/${type}/${id}`),
    enable: (type, id) => axios.patch(`/params/${type}/${id}/enable`),
    disable: (type, id) => axios.patch(`/params/${type}/${id}/disable`),
    multi(type, data) {
        data.append("_METHOD", "PUT");
        return axios.post(`/params/${type}/multi`, data);
    },
}